import { DOM } from '../variables'

export const header = () => {}
